import React, { useEffect, useState } from 'react'

import Components from '../../../components'
import Client from '../../../services'


const MarksheetRow = ({entry, onSave}) => {
    const [edit, setEdit] = useState(entry.edit)
    const [data, setData] = useState({...entry}) 

    useEffect(()=> {
        setEdit(entry.edit)
    }, [entry])

    const handleChange = (e) =>{
        const {name, value} = e.target;
        setData({ ...data, [name]: value})
    }

    const handleCancel = () => {
        setData({...entry})
        setEdit(false)
    } 
    const handleSave = async () => {
        if(onSave) {
            const updatedEntry = await onSave(data)
            if(updatedEntry) {
                setData({...data, grade: updatedEntry.grade })
                setEdit(false)
            }
        }
    }

    if(edit){
        return <tr>
            <td>{data.title}</td>
            <td style={{width: "100px"}}>
                <Components.input.TextInput type="number" name="fullMarks" style={{width: "90%"}} value={data.fullMarks} onChange={handleChange}/>
            </td>
            <td style={{width: "100px"}}>
                <Components.input.TextInput type="number" name="marks" style={{width: "90%"}} value={data.marks} onChange={handleChange}/>
            </td>
            <td style={{width: "100px"}}>
                <Components.input.TextInput type="number" name="timeTaken" style={{width: "90%"}} value={data.timeTaken} onChange={handleChange}/>
            </td>
            <td style={{width: "50px"}}>{data.grade}</td>
            <td style={{width: "200px"}}>
                <Components.input.TextInput type="date" name="examDate" style={{width: "90%"}} value={data.examDate} onChange={handleChange}/>
            </td>
            {
                (Client.session.ofManagement || Client.session.ofTeacher) &&
                <td>
                    <div style={{display: "flex"}}>
                        <Components.buttons.FlatButton onClick={handleSave}>Save</Components.buttons.FlatButton>
                        <Components.buttons.FlatButton onClick={handleCancel}>Cancel</Components.buttons.FlatButton>
                    </div>
                </td>

            }
        </tr>
    }

    return <tr>
        <td>{data.title ?? "-"}</td>
        <td style={{width: "100px"}}>{data.fullMarks ?? "-"}</td>
        <td style={{width: "100px"}}>{data.marks ?? "-"}</td>
        <td style={{width: "100px"}}>{data.timeTaken ?? "-"}</td>
        <td style={{width: "50px"}}>{data.grade ?? "-"}</td>
        <td style={{width: "200px"}}>{data.examDate ?? "-"}</td>
        {
            (Client.session.ofManagement || Client.session.ofTeacher) &&
            <td>
                <Components.buttons.FlatButton onClick={()=>setEdit(true)}>Edit</Components.buttons.FlatButton>
            </td>
        }

    </tr>
}

export default MarksheetRow

